module.exports = __webpack_public_path__ + "static/media/CheckCanEat.6b6a50e2.jpg";